// Client-facing translations (English / Hindi). Admin UI stays English.
export const translations = {
  en: {
    lang_name: "EN",
    start_checkup: "Start Check-Up",
    // hero
    badge: "Financial Health Check-Up",
    hero_line1: "Know Your Financial Health.",
    hero_line2: "Plan Your Future.",
    hero_sub: "Answer a few simple questions and discover the areas of your financial life that may need attention.",
    bullets: [
      "Takes only 3–5 minutes", "Confidential assessment", "Personalized financial health score",
      "Identify your top 3 financial priorities", "Get a personalized improvement report",
    ],
    cta_primary: "START MY FREE CHECK-UP",
    cta_secondary: "HOW IT WORKS",
    score_card_title: "Your Health Score",
    score_card_sub: "Across 6 financial areas",
    score_areas: ["Protection", "Preparedness", "Wealth Creation", "Goals", "Retirement", "Knowledge"],
    confidential_nologin: "Confidential · No login required",
    // why
    why_overline: "Why take the check-up?",
    why_title: "Your financial health is about more than how much you earn.",
    why: [
      { title: "Protect Your Family", desc: "Ensure your loved ones are financially secure, whatever life brings." },
      { title: "Build Financial Security", desc: "Create a resilient foundation with reserves and the right cover." },
      { title: "Grow Your Wealth", desc: "Put your money to work through consistent, structured investing." },
      { title: "Plan Major Goals", desc: "Fund education, a home and milestones with clarity and confidence." },
      { title: "Prepare for Retirement", desc: "Build a corpus that supports the lifestyle you want, later in life." },
      { title: "Improve Financial Confidence", desc: "Understand where you stand and what to prioritise next." },
    ],
    // how
    how_overline: "How it works",
    how_title: "Four simple steps to financial clarity",
    steps: [
      { title: "Answer 12 simple questions", desc: "No jargon. Just honest, quick responses." },
      { title: "Get your Financial Health Score", desc: "A clear score out of 60 across six areas." },
      { title: "Discover your financial gaps", desc: "See exactly where attention is needed." },
      { title: "Get your improvement plan", desc: "Personalised, educational next steps." },
    ],
    dimensions_title: "Financial health includes eight dimensions",
    dimensions: ["Protection", "Savings", "Emergency", "Debt", "Investments", "Goals", "Retirement", "Knowledge"],
    final_title: "Take Control of Your Financial Future",
    final_sub: "Knowing your gaps is the first step. Taking action is the next.",
    final_cta: "START MY CHECK-UP",
    minutes: "3–5 minutes",
    confidential: "Confidential",
    // assessment
    question_of: "Question {n} of {t}",
    percent_complete: "{p}% Complete",
    back: "Back",
    next: "Next",
    see_results: "See My Results",
    exit: "Exit",
    select_option: "Please select an option to continue.",
    // result
    report_overline: "Your Financial Health Report",
    report_title: "Here is where you stand today",
    report_sub: "Your score reflects six key areas of financial health. Explore your strongest areas and where attention may help most.",
    strongest: "Your strongest areas",
    attention: "Areas that may need attention",
    category_breakdown: "Category Breakdown",
    not_applicable: "Not applicable to you",
    report_ready_title: "Your Financial Health Report Is Ready",
    report_ready_sub: "Where should we send your detailed report and Top 3 priorities?",
    full_name: "Full Name", mobile: "Mobile Number", email: "Email Address", city: "City",
    age_group: "Age Group", income_range: "Annual Income Range",
    help_personalise: "Help us personalise further (optional)", hide_optional: "Hide optional questions",
    consent_text: "I agree to be contacted regarding my financial health assessment and financial planning discussion.",
    get_report: "GET MY FINANCIAL HEALTH REPORT",
    top3_title: "Your Top 3 Financial Priorities",
    gaps_title: "Identified Gaps & Suggestions",
    please_note: "Please note:",
    ready_title: "Ready to Improve Your Financial Health?",
    ready_sub: "Your assessment has identified areas that may deserve attention. A personalized financial planning discussion can help you quantify these gaps and prioritize your next steps.",
    whatsapp_us: "WhatsApp Us", book_meeting: "Book a Meeting", download_report: "Download My Report",
    try_calculators: "Try free calculators to plan your gaps →",
    emailed_note: "A copy of your report has been emailed to you.",
    your_report: "Your Report",
    priority_titles: {}, priority_messages: {}, gap_titles: {}, gap_suggestions: {},
    rating_labels: {},
  },
  hi: {
    lang_name: "हिंदी",
    start_checkup: "जाँच शुरू करें",
    badge: "वित्तीय स्वास्थ्य जाँच",
    hero_line1: "अपना वित्तीय स्वास्थ्य जानें।",
    hero_line2: "अपना भविष्य संवारें।",
    hero_sub: "कुछ आसान सवालों के जवाब दें और जानें कि आपके वित्तीय जीवन के किन हिस्सों पर ध्यान देने की ज़रूरत है।",
    bullets: [
      "केवल 3–5 मिनट", "गोपनीय मूल्यांकन", "व्यक्तिगत वित्तीय स्वास्थ्य स्कोर",
      "अपनी शीर्ष 3 वित्तीय प्राथमिकताएँ जानें", "व्यक्तिगत सुधार रिपोर्ट पाएँ",
    ],
    cta_primary: "मेरी मुफ़्त जाँच शुरू करें",
    cta_secondary: "यह कैसे काम करता है",
    score_card_title: "आपका स्वास्थ्य स्कोर",
    score_card_sub: "6 वित्तीय क्षेत्रों में",
    score_areas: ["सुरक्षा", "तैयारी", "संपत्ति निर्माण", "लक्ष्य", "सेवानिवृत्ति", "ज्ञान"],
    confidential_nologin: "गोपनीय · लॉगिन की ज़रूरत नहीं",
    why_overline: "जाँच क्यों करें?",
    why_title: "आपका वित्तीय स्वास्थ्य सिर्फ़ आपकी कमाई से कहीं ज़्यादा है।",
    why: [
      { title: "अपने परिवार की सुरक्षा", desc: "जीवन में कुछ भी हो, अपनों को आर्थिक रूप से सुरक्षित रखें।" },
      { title: "वित्तीय सुरक्षा बनाएँ", desc: "पर्याप्त कोष और सही बीमा के साथ मज़बूत नींव बनाएँ।" },
      { title: "अपनी संपत्ति बढ़ाएँ", desc: "नियमित, ढाँचागत निवेश के ज़रिए अपने पैसे को काम पर लगाएँ।" },
      { title: "बड़े लक्ष्यों की योजना", desc: "शिक्षा, घर और अहम पड़ावों को स्पष्टता से वित्तपोषित करें।" },
      { title: "सेवानिवृत्ति की तैयारी", desc: "ऐसा कोष बनाएँ जो बाद के जीवन में आपकी इच्छित जीवनशैली संभाले।" },
      { title: "वित्तीय आत्मविश्वास बढ़ाएँ", desc: "समझें कि आप कहाँ खड़े हैं और आगे क्या प्राथमिकता दें।" },
    ],
    how_overline: "यह कैसे काम करता है",
    how_title: "वित्तीय स्पष्टता के लिए चार आसान कदम",
    steps: [
      { title: "12 आसान सवालों के जवाब दें", desc: "कोई जटिल शब्दावली नहीं। बस सच्चे, त्वरित जवाब।" },
      { title: "अपना वित्तीय स्वास्थ्य स्कोर पाएँ", desc: "छह क्षेत्रों में 60 में से स्पष्ट स्कोर।" },
      { title: "अपने वित्तीय अंतराल जानें", desc: "देखें कि ठीक कहाँ ध्यान देने की ज़रूरत है।" },
      { title: "अपनी सुधार योजना पाएँ", desc: "व्यक्तिगत, शैक्षिक अगले कदम।" },
    ],
    dimensions_title: "वित्तीय स्वास्थ्य में आठ आयाम शामिल हैं",
    dimensions: ["सुरक्षा", "बचत", "आपातकाल", "कर्ज़", "निवेश", "लक्ष्य", "सेवानिवृत्ति", "ज्ञान"],
    final_title: "अपने वित्तीय भविष्य की कमान संभालें",
    final_sub: "अपने अंतराल जानना पहला कदम है। कार्रवाई करना अगला।",
    final_cta: "मेरी जाँच शुरू करें",
    minutes: "3–5 मिनट",
    confidential: "गोपनीय",
    question_of: "प्रश्न {n} / {t}",
    percent_complete: "{p}% पूर्ण",
    back: "पीछे",
    next: "आगे",
    see_results: "मेरे परिणाम देखें",
    exit: "बाहर",
    select_option: "जारी रखने के लिए कृपया एक विकल्प चुनें।",
    report_overline: "आपकी वित्तीय स्वास्थ्य रिपोर्ट",
    report_title: "आज आप यहाँ खड़े हैं",
    report_sub: "आपका स्कोर वित्तीय स्वास्थ्य के छह प्रमुख क्षेत्रों को दर्शाता है। अपनी सबसे मज़बूत जगहें और जहाँ ध्यान सबसे ज़्यादा मदद करेगा, देखें।",
    strongest: "आपकी सबसे मज़बूत जगहें",
    attention: "जिन पर ध्यान देने की ज़रूरत हो सकती है",
    category_breakdown: "श्रेणीवार विश्लेषण",
    not_applicable: "आप पर लागू नहीं",
    report_ready_title: "आपकी वित्तीय स्वास्थ्य रिपोर्ट तैयार है",
    report_ready_sub: "हम आपकी विस्तृत रिपोर्ट और शीर्ष 3 प्राथमिकताएँ कहाँ भेजें?",
    full_name: "पूरा नाम", mobile: "मोबाइल नंबर", email: "ईमेल पता", city: "शहर",
    age_group: "आयु वर्ग", income_range: "वार्षिक आय सीमा",
    help_personalise: "और व्यक्तिगत बनाने में मदद करें (वैकल्पिक)", hide_optional: "वैकल्पिक प्रश्न छिपाएँ",
    consent_text: "मैं अपनी वित्तीय स्वास्थ्य जाँच और वित्तीय योजना चर्चा के संबंध में संपर्क किए जाने के लिए सहमत हूँ।",
    get_report: "मेरी वित्तीय स्वास्थ्य रिपोर्ट पाएँ",
    top3_title: "आपकी शीर्ष 3 वित्तीय प्राथमिकताएँ",
    gaps_title: "पहचाने गए अंतराल और सुझाव",
    please_note: "कृपया ध्यान दें:",
    ready_title: "अपना वित्तीय स्वास्थ्य सुधारने के लिए तैयार हैं?",
    ready_sub: "आपकी जाँच ने ऐसे क्षेत्र पहचाने हैं जिन पर ध्यान देना उचित हो सकता है। एक व्यक्तिगत वित्तीय योजना चर्चा इन अंतरालों को मापने और अगले कदम तय करने में मदद कर सकती है।",
    whatsapp_us: "व्हाट्सएप करें", book_meeting: "मीटिंग बुक करें", download_report: "मेरी रिपोर्ट डाउनलोड करें",
    try_calculators: "अपने अंतराल की योजना के लिए मुफ़्त कैलकुलेटर आज़माएँ →",
    emailed_note: "आपकी रिपोर्ट की एक प्रति आपको ईमेल कर दी गई है।",
    your_report: "आपकी रिपोर्ट",
    priority_titles: {
      PROTECT: "जीवन एवं स्वास्थ्य सुरक्षा", PREPARE: "आपातकालीन एवं ऋण तैयारी",
      GROW: "संपत्ति निर्माण", GOALS: "लक्ष्य योजना", RETIRE: "सेवानिवृत्ति योजना", KNOW: "वित्तीय ज्ञान",
    },
    priority_messages: {
      PROTECT: "आपके उत्तर बताते हैं कि आपके परिवार की वित्तीय सुरक्षा की समीक्षा ज़रूरी हो सकती है।",
      PREPARE: "आपके उत्तर बताते हैं कि आपकी आपातकालीन तैयारी या ऋण प्रबंधन पर ध्यान देने की ज़रूरत हो सकती है।",
      GROW: "आपके उत्तर बताते हैं कि आपकी दीर्घकालिक संपत्ति निर्माण रणनीति को मज़बूत करने की ज़रूरत हो सकती है।",
      GOALS: "आपके उत्तर बताते हैं कि आपके बड़े वित्तीय लक्ष्यों के लिए ढाँचागत योजना की ज़रूरत हो सकती है।",
      RETIRE: "आपके उत्तर बताते हैं कि आपकी सेवानिवृत्ति योजना में अधिक स्पष्टता की ज़रूरत हो सकती है।",
      KNOW: "आपके उत्तर बताते हैं कि वित्तीय आत्मविश्वास बढ़ाना आपके निर्णयों में मदद कर सकता है।",
    },
    gap_titles: {
      life_insurance: "पारिवारिक सुरक्षा अंतराल", health_insurance: "स्वास्थ्य सुरक्षा अंतराल",
      emergency_fund: "आपातकालीन कोष अंतराल", debt_health: "ऋण दबाव अंतराल",
      savings_habit: "बचत आदत अंतराल", investment_habit: "संपत्ति निर्माण अंतराल",
      children_education: "बच्चों के भविष्य का अंतराल", family_goals: "बड़े लक्ष्यों का अंतराल",
      retirement: "सेवानिवृत्ति योजना अंतराल", financial_knowledge: "वित्तीय ज्ञान अंतराल",
      investment_behaviour: "निवेश व्यवहार अंतराल", written_goals: "वित्तीय लक्ष्य स्पष्टता अंतराल",
    },
    gap_suggestions: {
      life_insurance: "आय, आश्रितों, देनदारियों, मौजूदा संपत्तियों और भविष्य के लक्ष्यों को ध्यान में रखते हुए अपनी जीवन सुरक्षा आवश्यकता की समीक्षा करें।",
      health_insurance: "अपने परिवार के स्वास्थ्य बीमा कवर और संभावित चिकित्सा खर्च जोखिम की समीक्षा करें।",
      emergency_fund: "अत्यधिक दीर्घकालिक निवेश जोखिम लेने से पहले एक आपातकालीन कोष बनाने पर विचार करें।",
      debt_health: "अपने ऋण दायित्वों की समीक्षा करें और उच्च-दबाव वाले कर्ज़ को प्रबंधित या कम करने के लिए एक ढाँचागत योजना पर विचार करें।",
      savings_habit: "खर्च करने से पहले हर महीने एक नियमित बचत राशि स्वचालित करने पर विचार करें।",
      investment_habit: "अपने लक्ष्यों और जोखिम प्रोफ़ाइल के अनुरूप एक ढाँचागत दीर्घकालिक निवेश रणनीति विकसित करने पर विचार करें।",
      children_education: "एक शिक्षा लक्ष्य राशि और समय-सीमा तय करें, फिर उसके लिए ढाँचागत निवेश शुरू करें।",
      family_goals: "अपने बड़े जीवन लक्ष्यों को राशि और समय-सीमा के साथ पहचानें, और उन्हें वित्तपोषित करने के लिए निवेश संरेखित करें।",
      retirement: "अपनी सेवानिवृत्ति कोष आवश्यकता का अनुमान लगाएँ और एक दीर्घकालिक सेवानिवृत्ति रणनीति बनाएँ।",
      financial_knowledge: "जोखिम, महँगाई और विविधीकरण जैसी मूल अवधारणाओं की अपनी समझ बढ़ाने पर विचार करें।",
      investment_behaviour: "यह केवल एक प्रारंभिक व्यवहारिक संकेत है। एक ढाँचागत जोखिम प्रोफ़ाइलिंग अभ्यास उपयुक्त निर्णयों में मार्गदर्शन कर सकता है।",
      written_goals: "अपने बड़े वित्तीय लक्ष्य, लक्ष्य राशियाँ और समय-सीमाएँ तय करें।",
    },
    rating_labels: {
      "Excellent Financial Foundation": "उत्कृष्ट वित्तीय नींव",
      "Good Financial Foundation": "अच्छी वित्तीय नींव",
      "Needs Structured Planning": "ढाँचागत योजना की ज़रूरत",
      "At Risk": "जोखिम में",
      "Critical Financial Gaps": "गंभीर वित्तीय अंतराल",
    },
  },
  mr: {
    lang_name: "मराठी",
    start_checkup: "तपासणी सुरू करा",
    badge: "आर्थिक आरोग्य तपासणी",
    hero_line1: "तुमचे आर्थिक आरोग्य जाणून घ्या.",
    hero_line2: "तुमचे भविष्य घडवा.",
    hero_sub: "काही सोप्या प्रश्नांची उत्तरे द्या आणि तुमच्या आर्थिक जीवनातील ज्या भागांकडे लक्ष देण्याची गरज आहे ते जाणून घ्या.",
    bullets: [
      "फक्त 3–5 मिनिटे", "गोपनीय मूल्यांकन", "वैयक्तिक आर्थिक आरोग्य स्कोअर",
      "तुमच्या शीर्ष 3 आर्थिक प्राधान्यक्रम जाणा", "वैयक्तिक सुधारणा अहवाल मिळवा",
    ],
    cta_primary: "माझी मोफत तपासणी सुरू करा",
    cta_secondary: "हे कसे कार्य करते",
    score_card_title: "तुमचा आरोग्य स्कोअर",
    score_card_sub: "6 आर्थिक क्षेत्रांमध्ये",
    score_areas: ["संरक्षण", "तयारी", "संपत्ती निर्मिती", "उद्दिष्टे", "निवृत्ती", "ज्ञान"],
    confidential_nologin: "गोपनीय · लॉगिनची गरज नाही",
    why_overline: "तपासणी का करावी?",
    why_title: "तुमचे आर्थिक आरोग्य फक्त तुमच्या कमाईपेक्षा खूप अधिक आहे.",
    why: [
      { title: "आपल्या कुटुंबाचे रक्षण", desc: "जीवनात काहीही घडो, आपल्या प्रियजनांना आर्थिकदृष्ट्या सुरक्षित ठेवा." },
      { title: "आर्थिक सुरक्षा उभारा", desc: "पुरेसा निधी आणि योग्य विम्यासह भक्कम पाया तयार करा." },
      { title: "तुमची संपत्ती वाढवा", desc: "नियमित, रचनात्मक गुंतवणुकीद्वारे तुमचा पैसा कामाला लावा." },
      { title: "मोठ्या उद्दिष्टांचे नियोजन", desc: "शिक्षण, घर व महत्त्वाचे टप्पे स्पष्टतेने निधीबद्ध करा." },
      { title: "निवृत्तीची तयारी", desc: "पुढील आयुष्यात हवी असलेली जीवनशैली सांभाळणारा निधी उभारा." },
      { title: "आर्थिक आत्मविश्वास वाढवा", desc: "तुम्ही कुठे आहात व पुढे कशाला प्राधान्य द्यायचे ते समजून घ्या." },
    ],
    how_overline: "हे कसे कार्य करते",
    how_title: "आर्थिक स्पष्टतेसाठी चार सोपे टप्पे",
    steps: [
      { title: "12 सोप्या प्रश्नांची उत्तरे द्या", desc: "क्लिष्ट शब्द नाहीत. फक्त प्रामाणिक, झटपट उत्तरे." },
      { title: "तुमचा आर्थिक आरोग्य स्कोअर मिळवा", desc: "सहा क्षेत्रांमध्ये 60 पैकी स्पष्ट स्कोअर." },
      { title: "तुमच्या आर्थिक त्रुटी जाणा", desc: "नेमके कुठे लक्ष द्यायचे ते पाहा." },
      { title: "तुमची सुधारणा योजना मिळवा", desc: "वैयक्तिक, शैक्षणिक पुढील पावले." },
    ],
    dimensions_title: "आर्थिक आरोग्यात आठ आयाम असतात",
    dimensions: ["संरक्षण", "बचत", "आपत्काल", "कर्ज", "गुंतवणूक", "उद्दिष्टे", "निवृत्ती", "ज्ञान"],
    final_title: "तुमच्या आर्थिक भविष्याची सूत्रे हाती घ्या",
    final_sub: "तुमच्या त्रुटी जाणणे हे पहिले पाऊल आहे. कृती करणे हे पुढचे.",
    final_cta: "माझी तपासणी सुरू करा",
    minutes: "3–5 मिनिटे",
    confidential: "गोपनीय",
    question_of: "प्रश्न {n} / {t}",
    percent_complete: "{p}% पूर्ण",
    back: "मागे",
    next: "पुढे",
    see_results: "माझे निकाल पाहा",
    exit: "बाहेर",
    select_option: "पुढे जाण्यासाठी कृपया एक पर्याय निवडा.",
    report_overline: "तुमचा आर्थिक आरोग्य अहवाल",
    report_title: "आज तुम्ही इथे आहात",
    report_sub: "तुमचा स्कोअर आर्थिक आरोग्याची सहा प्रमुख क्षेत्रे दर्शवतो. तुमच्या सर्वात भक्कम जागा आणि जिथे लक्ष सर्वाधिक मदत करेल ते पाहा.",
    strongest: "तुमच्या सर्वात भक्कम जागा",
    attention: "ज्यांकडे लक्ष देण्याची गरज असू शकते",
    category_breakdown: "श्रेणीनिहाय विश्लेषण",
    not_applicable: "तुम्हाला लागू नाही",
    report_ready_title: "तुमचा आर्थिक आरोग्य अहवाल तयार आहे",
    report_ready_sub: "आम्ही तुमचा सविस्तर अहवाल व शीर्ष 3 प्राधान्यक्रम कुठे पाठवावेत?",
    full_name: "पूर्ण नाव", mobile: "मोबाईल नंबर", email: "ईमेल पत्ता", city: "शहर",
    age_group: "वयोगट", income_range: "वार्षिक उत्पन्न श्रेणी",
    help_personalise: "अधिक वैयक्तिक करण्यास मदत करा (ऐच्छिक)", hide_optional: "ऐच्छिक प्रश्न लपवा",
    consent_text: "माझ्या आर्थिक आरोग्य तपासणी व आर्थिक नियोजन चर्चेबाबत संपर्क साधण्यास मी सहमत आहे.",
    get_report: "माझा आर्थिक आरोग्य अहवाल मिळवा",
    top3_title: "तुमच्या शीर्ष 3 आर्थिक प्राधान्यक्रम",
    gaps_title: "ओळखलेल्या त्रुटी व सूचना",
    please_note: "कृपया लक्षात घ्या:",
    ready_title: "तुमचे आर्थिक आरोग्य सुधारण्यास तयार आहात?",
    ready_sub: "तुमच्या तपासणीने अशी क्षेत्रे ओळखली आहेत ज्यांकडे लक्ष देणे योग्य ठरेल. वैयक्तिक आर्थिक नियोजन चर्चा या त्रुटी मोजण्यास व पुढील पावले ठरवण्यास मदत करू शकते.",
    whatsapp_us: "व्हॉट्सअ‍ॅप करा", book_meeting: "मीटिंग बुक करा", download_report: "माझा अहवाल डाउनलोड करा",
    try_calculators: "तुमच्या त्रुटींचे नियोजन करण्यासाठी मोफत कॅल्क्युलेटर वापरा →",
    emailed_note: "तुमच्या अहवालाची एक प्रत तुम्हाला ईमेल केली आहे.",
    your_report: "तुमचा अहवाल",
    priority_titles: {
      PROTECT: "जीवन व आरोग्य संरक्षण", PREPARE: "आपत्कालीन व कर्ज तयारी",
      GROW: "संपत्ती निर्मिती", GOALS: "उद्दिष्ट नियोजन", RETIRE: "निवृत्ती नियोजन", KNOW: "आर्थिक ज्ञान",
    },
    priority_messages: {
      PROTECT: "तुमची उत्तरे दर्शवतात की तुमच्या कुटुंबाच्या आर्थिक संरक्षणाचा आढावा घेणे आवश्यक असू शकते.",
      PREPARE: "तुमची उत्तरे दर्शवतात की तुमची आपत्कालीन तयारी किंवा कर्ज व्यवस्थापन याकडे लक्ष देणे आवश्यक असू शकते.",
      GROW: "तुमची उत्तरे दर्शवतात की तुमची दीर्घकालीन संपत्ती निर्मिती रणनीती बळकट करणे आवश्यक असू शकते.",
      GOALS: "तुमची उत्तरे दर्शवतात की तुमच्या मोठ्या आर्थिक उद्दिष्टांसाठी रचनात्मक नियोजन आवश्यक असू शकते.",
      RETIRE: "तुमची उत्तरे दर्शवतात की तुमच्या निवृत्ती नियोजनात अधिक स्पष्टता आवश्यक असू शकते.",
      KNOW: "तुमची उत्तरे दर्शवतात की आर्थिक आत्मविश्वास वाढवणे तुमच्या निर्णयांना मदत करू शकते.",
    },
    gap_titles: {
      life_insurance: "कौटुंबिक संरक्षण त्रुटी", health_insurance: "आरोग्य संरक्षण त्रुटी",
      emergency_fund: "आपत्कालीन निधी त्रुटी", debt_health: "कर्ज दबाव त्रुटी",
      savings_habit: "बचत सवय त्रुटी", investment_habit: "संपत्ती निर्मिती त्रुटी",
      children_education: "मुलांच्या भविष्याची त्रुटी", family_goals: "मोठ्या उद्दिष्टांची त्रुटी",
      retirement: "निवृत्ती नियोजन त्रुटी", financial_knowledge: "आर्थिक ज्ञान त्रुटी",
      investment_behaviour: "गुंतवणूक वर्तन त्रुटी", written_goals: "आर्थिक उद्दिष्ट स्पष्टता त्रुटी",
    },
    gap_suggestions: {
      life_insurance: "उत्पन्न, अवलंबित व्यक्ती, देणी, विद्यमान मालमत्ता आणि भविष्यातील उद्दिष्टे विचारात घेऊन तुमच्या जीवन संरक्षण गरजेचा आढावा घ्या.",
      health_insurance: "तुमच्या कुटुंबाच्या आरोग्य विमा संरक्षणाचा आणि संभाव्य वैद्यकीय खर्च जोखमीचा आढावा घ्या.",
      emergency_fund: "जास्त दीर्घकालीन गुंतवणूक जोखीम घेण्यापूर्वी आपत्कालीन निधी उभारण्याचा विचार करा.",
      debt_health: "तुमच्या कर्ज जबाबदाऱ्यांचा आढावा घ्या आणि जास्त दबावाचे कर्ज व्यवस्थापित किंवा कमी करण्यासाठी रचनात्मक योजनेचा विचार करा.",
      savings_habit: "खर्च करण्यापूर्वी दरमहा नियमित बचत रक्कम स्वयंचलित करण्याचा विचार करा.",
      investment_habit: "तुमच्या उद्दिष्टे व जोखीम प्रोफाइलनुसार रचनात्मक दीर्घकालीन गुंतवणूक रणनीती विकसित करण्याचा विचार करा.",
      children_education: "शिक्षण उद्दिष्ट रक्कम व कालमर्यादा निश्चित करा, नंतर त्यासाठी रचनात्मक गुंतवणूक सुरू करा.",
      family_goals: "तुमची मोठी जीवन उद्दिष्टे रक्कम व कालमर्यादेसह ओळखा आणि ती पूर्ण करण्यासाठी गुंतवणूक संरेखित करा.",
      retirement: "तुमच्या निवृत्ती निधीची गरज अंदाजित करा आणि दीर्घकालीन निवृत्ती रणनीती तयार करा.",
      financial_knowledge: "जोखीम, महागाई व विविधीकरण यांसारख्या मूलभूत संकल्पनांची समज वाढवण्याचा विचार करा.",
      investment_behaviour: "हा केवळ प्रारंभिक वर्तनात्मक संकेत आहे. रचनात्मक जोखीम प्रोफाइलिंग व्यायाम योग्य निर्णयांसाठी मार्गदर्शन करू शकतो.",
      written_goals: "तुमची मोठी आर्थिक उद्दिष्टे, लक्ष्य रकमा व कालमर्यादा निश्चित करा.",
    },
    rating_labels: {
      "Excellent Financial Foundation": "उत्कृष्ट आर्थिक पाया",
      "Good Financial Foundation": "चांगला आर्थिक पाया",
      "Needs Structured Planning": "रचनात्मक नियोजनाची गरज",
      "At Risk": "जोखमीत",
      "Critical Financial Gaps": "गंभीर आर्थिक त्रुटी",
    },
  },
  gu: {
    lang_name: "ગુજરાતી",
    start_checkup: "તપાસ શરૂ કરો",
    badge: "આર્થિક આરોગ્ય તપાસ",
    hero_line1: "તમારું આર્થિક આરોગ્ય જાણો.",
    hero_line2: "તમારું ભવિષ્ય ઘડો.",
    hero_sub: "થોડા સરળ પ્રશ્નોના જવાબ આપો અને જાણો કે તમારા આર્થિક જીવનના કયા ભાગો પર ધ્યાન આપવાની જરૂર છે.",
    bullets: [
      "માત્ર 3–5 મિનિટ", "ગોપનીય મૂલ્યાંકન", "વ્યક્તિગત આર્થિક આરોગ્ય સ્કોર",
      "તમારી ટોચની 3 આર્થિક પ્રાથમિકતાઓ જાણો", "વ્યક્તિગત સુધારણા અહેવાલ મેળવો",
    ],
    cta_primary: "મારી મફત તપાસ શરૂ કરો",
    cta_secondary: "આ કેવી રીતે કામ કરે છે",
    score_card_title: "તમારો આરોગ્ય સ્કોર",
    score_card_sub: "6 આર્થિક ક્ષેત્રોમાં",
    score_areas: ["સંરક્ષણ", "તૈયારી", "સંપત્તિ સર્જન", "લક્ષ્યો", "નિવૃત્તિ", "જ્ઞાન"],
    confidential_nologin: "ગોપનીય · લૉગિનની જરૂર નથી",
    why_overline: "તપાસ કેમ કરવી?",
    why_title: "તમારું આર્થિક આરોગ્ય તમે કેટલું કમાઓ છો તેના કરતાં ઘણું વધારે છે.",
    why: [
      { title: "તમારા પરિવારનું રક્ષણ કરો", desc: "જીવનમાં જે પણ આવે, તમારા પ્રિયજનોને આર્થિક રીતે સુરક્ષિત રાખો." },
      { title: "આર્થિક સુરક્ષા બનાવો", desc: "પૂરતા ભંડોળ અને યોગ્ય વીમા સાથે મજબૂત પાયો બનાવો." },
      { title: "તમારી સંપત્તિ વધારો", desc: "નિયમિત, રચનાત્મક રોકાણ દ્વારા તમારા પૈસાને કામે લગાડો." },
      { title: "મોટા લક્ષ્યોનું આયોજન", desc: "શિક્ષણ, ઘર અને મહત્વના પડાવોને સ્પષ્ટતાથી ભંડોળ પૂરું પાડો." },
      { title: "નિવૃત્તિની તૈયારી", desc: "પછીના જીવનમાં ઇચ્છિત જીવનશૈલી ટકાવે તેવો ભંડોળ બનાવો." },
      { title: "આર્થિક આત્મવિશ્વાસ વધારો", desc: "તમે ક્યાં ઊભા છો અને આગળ શેને પ્રાથમિકતા આપવી તે સમજો." },
    ],
    how_overline: "આ કેવી રીતે કામ કરે છે",
    how_title: "આર્થિક સ્પષ્ટતા માટે ચાર સરળ પગલાં",
    steps: [
      { title: "12 સરળ પ્રશ્નોના જવાબ આપો", desc: "કોઈ અઘરા શબ્દો નહીં. ફક્ત પ્રામાણિક, ઝડપી જવાબો." },
      { title: "તમારો આર્થિક આરોગ્ય સ્કોર મેળવો", desc: "છ ક્ષેત્રોમાં 60 માંથી સ્પષ્ટ સ્કોર." },
      { title: "તમારી આર્થિક ખામીઓ જાણો", desc: "બરાબર ક્યાં ધ્યાન આપવાની જરૂર છે તે જુઓ." },
      { title: "તમારી સુધારણા યોજના મેળવો", desc: "વ્યક્તિગત, શૈક્ષણિક આગળનાં પગલાં." },
    ],
    dimensions_title: "આર્થિક આરોગ્યમાં આઠ પરિમાણો હોય છે",
    dimensions: ["સંરક્ષણ", "બચત", "કટોકટી", "દેવું", "રોકાણ", "લક્ષ્યો", "નિવૃત્તિ", "જ્ઞાન"],
    final_title: "તમારા આર્થિક ભવિષ્યની લગામ સંભાળો",
    final_sub: "તમારી ખામીઓ જાણવી એ પહેલું પગલું છે. પગલાં લેવાં એ આગળનું.",
    final_cta: "મારી તપાસ શરૂ કરો",
    minutes: "3–5 મિનિટ",
    confidential: "ગોપનીય",
    question_of: "પ્રશ્ન {n} / {t}",
    percent_complete: "{p}% પૂર્ણ",
    back: "પાછળ",
    next: "આગળ",
    see_results: "મારા પરિણામો જુઓ",
    exit: "બહાર",
    select_option: "આગળ વધવા માટે કૃપા કરીને એક વિકલ્પ પસંદ કરો.",
    report_overline: "તમારો આર્થિક આરોગ્ય અહેવાલ",
    report_title: "આજે તમે અહીં ઊભા છો",
    report_sub: "તમારો સ્કોર આર્થિક આરોગ્યના છ મુખ્ય ક્ષેત્રો દર્શાવે છે. તમારી સૌથી મજબૂત જગ્યાઓ અને જ્યાં ધ્યાન સૌથી વધુ મદદ કરશે તે જુઓ.",
    strongest: "તમારી સૌથી મજબૂત જગ્યાઓ",
    attention: "જેના પર ધ્યાન આપવાની જરૂર હોઈ શકે",
    category_breakdown: "શ્રેણી પ્રમાણે વિશ્લેષણ",
    not_applicable: "તમને લાગુ પડતું નથી",
    report_ready_title: "તમારો આર્થિક આરોગ્ય અહેવાલ તૈયાર છે",
    report_ready_sub: "અમે તમારો વિગતવાર અહેવાલ અને ટોચની 3 પ્રાથમિકતાઓ ક્યાં મોકલીએ?",
    full_name: "પૂરું નામ", mobile: "મોબાઇલ નંબર", email: "ઈમેલ સરનામું", city: "શહેર",
    age_group: "વયજૂથ", income_range: "વાર્ષિક આવક શ્રેણી",
    help_personalise: "વધુ વ્યક્તિગત બનાવવામાં મદદ કરો (વૈકલ્પિક)", hide_optional: "વૈકલ્પિક પ્રશ્નો છુપાવો",
    consent_text: "મારી આર્થિક આરોગ્ય તપાસ અને આર્થિક આયોજન ચર્ચા અંગે સંપર્ક કરવા માટે હું સંમત છું.",
    get_report: "મારો આર્થિક આરોગ્ય અહેવાલ મેળવો",
    top3_title: "તમારી ટોચની 3 આર્થિક પ્રાથમિકતાઓ",
    gaps_title: "ઓળખાયેલી ખામીઓ અને સૂચનો",
    please_note: "કૃપા કરીને નોંધો:",
    ready_title: "તમારું આર્થિક આરોગ્ય સુધારવા તૈયાર છો?",
    ready_sub: "તમારી તપાસે એવા ક્ષેત્રો ઓળખ્યા છે જેના પર ધ્યાન આપવું યોગ્ય રહેશે. વ્યક્તિગત આર્થિક આયોજન ચર્ચા આ ખામીઓ માપવામાં અને આગળનાં પગલાં નક્કી કરવામાં મદદ કરી શકે છે.",
    whatsapp_us: "વૉટ્સએપ કરો", book_meeting: "મીટિંગ બુક કરો", download_report: "મારો અહેવાલ ડાઉનલોડ કરો",
    try_calculators: "તમારી ખામીઓનું આયોજન કરવા મફત કૅલ્ક્યુલેટર અજમાવો →",
    emailed_note: "તમારા અહેવાલની એક નકલ તમને ઈમેલ કરવામાં આવી છે.",
    your_report: "તમારો અહેવાલ",
    priority_titles: {
      PROTECT: "જીવન અને આરોગ્ય સંરક્ષણ", PREPARE: "કટોકટી અને દેવું તૈયારી",
      GROW: "સંપત્તિ સર્જન", GOALS: "લક્ષ્ય આયોજન", RETIRE: "નિવૃત્તિ આયોજન", KNOW: "આર્થિક જ્ઞાન",
    },
    priority_messages: {
      PROTECT: "તમારા જવાબો દર્શાવે છે કે તમારા પરિવારના આર્થિક સંરક્ષણની સમીક્ષા જરૂરી હોઈ શકે છે.",
      PREPARE: "તમારા જવાબો દર્શાવે છે કે તમારી કટોકટી તૈયારી કે દેવું વ્યવસ્થાપન પર ધ્યાન આપવાની જરૂર હોઈ શકે છે.",
      GROW: "તમારા જવાબો દર્શાવે છે કે તમારી લાંબા ગાળાની સંપત્તિ સર્જન વ્યૂહરચના મજબૂત કરવાની જરૂર હોઈ શકે છે.",
      GOALS: "તમારા જવાબો દર્શાવે છે કે તમારા મોટા આર્થિક લક્ષ્યો માટે રચનાત્મક આયોજનની જરૂર હોઈ શકે છે.",
      RETIRE: "તમારા જવાબો દર્શાવે છે કે તમારા નિવૃત્તિ આયોજનમાં વધુ સ્પષ્ટતાની જરૂર હોઈ શકે છે.",
      KNOW: "તમારા જવાબો દર્શાવે છે કે આર્થિક આત્મવિશ્વાસ વધારવો તમારા નિર્ણયોમાં મદદ કરી શકે છે.",
    },
    gap_titles: {
      life_insurance: "કૌટુંબિક સંરક્ષણ ખામી", health_insurance: "આરોગ્ય સંરક્ષણ ખામી",
      emergency_fund: "કટોકટી ભંડોળ ખામી", debt_health: "દેવું ભાર ખામી",
      savings_habit: "બચત આદત ખામી", investment_habit: "સંપત્તિ સર્જન ખામી",
      children_education: "બાળકોના ભવિષ્યની ખામી", family_goals: "મોટા લક્ષ્યોની ખામી",
      retirement: "નિવૃત્તિ આયોજન ખામી", financial_knowledge: "આર્થિક જ્ઞાન ખામી",
      investment_behaviour: "રોકાણ વર્તન ખામી", written_goals: "આર્થિક લક્ષ્ય સ્પષ્ટતા ખામી",
    },
    gap_suggestions: {
      life_insurance: "આવક, આશ્રિતો, જવાબદારીઓ, વર્તમાન સંપત્તિ અને ભવિષ્યના લક્ષ્યોને ધ્યાનમાં રાખીને તમારી જીવન સંરક્ષણ જરૂરિયાતની સમીક્ષા કરો.",
      health_insurance: "તમારા પરિવારના આરોગ્ય વીમા સંરક્ષણ અને સંભવિત તબીબી ખર્ચ જોખમની સમીક્ષા કરો.",
      emergency_fund: "વધુ પડતું લાંબા ગાળાનું રોકાણ જોખમ લેતા પહેલાં કટોકટી ભંડોળ ઊભું કરવાનું વિચારો.",
      debt_health: "તમારી લોન જવાબદારીઓની સમીક્ષા કરો અને ઊંચા ભારવાળા દેવાને વ્યવસ્થિત કે ઘટાડવા માટે રચનાત્મક યોજના વિચારો.",
      savings_habit: "ખર્ચ કરતા પહેલાં દર મહિને નિયમિત બચત રકમ સ્વયંસંચાલિત કરવાનું વિચારો.",
      investment_habit: "તમારા લક્ષ્યો અને જોખમ પ્રોફાઇલ પ્રમાણે રચનાત્મક લાંબા ગાળાની રોકાણ વ્યૂહરચના વિકસાવવાનું વિચારો.",
      children_education: "શિક્ષણ લક્ષ્ય રકમ અને સમયમર્યાદા નક્કી કરો, પછી તેના માટે રચનાત્મક રોકાણ શરૂ કરો.",
      family_goals: "તમારા મોટા જીવન લક્ષ્યોને રકમ અને સમયમર્યાદા સાથે ઓળખો, અને તેમને ભંડોળ પૂરું પાડવા રોકાણ ગોઠવો.",
      retirement: "તમારી નિવૃત્તિ ભંડોળ જરૂરિયાતનો અંદાજ કાઢો અને લાંબા ગાળાની નિવૃત્તિ વ્યૂહરચના બનાવો.",
      financial_knowledge: "જોખમ, ફુગાવો અને વૈવિધ્યકરણ જેવા મૂળભૂત ખ્યાલોની તમારી સમજ વધારવાનું વિચારો.",
      investment_behaviour: "આ માત્ર પ્રારંભિક વર્તન સંકેત છે. રચનાત્મક જોખમ પ્રોફાઇલિંગ કસરત યોગ્ય નિર્ણયો માટે માર્ગદર્શન આપી શકે છે.",
      written_goals: "તમારા મોટા આર્થિક લક્ષ્યો, લક્ષ્ય રકમો અને સમયમર્યાદા નક્કી કરો.",
    },
    rating_labels: {
      "Excellent Financial Foundation": "ઉત્કૃષ્ટ આર્થિક પાયો",
      "Good Financial Foundation": "સારો આર્થિક પાયો",
      "Needs Structured Planning": "રચનાત્મક આયોજનની જરૂર",
      "At Risk": "જોખમમાં",
      "Critical Financial Gaps": "ગંભીર આર્થિક ખામીઓ",
    },
  },
};
